<template>
  <generic-button
      @click="$emit('click')"
      :variant="variant"
      :title="withText?'delete':''"
      :icon="withIcon?(isOpen?'angle-up':'angle-down'):''"
      :size="size"
  />
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import GenericButton from './Button'

export default {
  components: {
    GenericButton
  },
  props: {
    withIcon: {
      type: Boolean,
      default: false
    },
    withText: {
      type: Boolean,
      default: true
    },
    withBorder: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'md'
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const variant = computed(() => {
      if (props.withBorder) {
        return 'outline-light-dark'
      } else {
        return 'flat-light-dark'
      }
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed
      variant,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>